import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Download } from "lucide-react";

interface QRCodeGeneratorProps {
  formId: string;
  formName: string;
}

export function QRCodeGenerator({ formId, formName }: QRCodeGeneratorProps) {
  const formUrl = `${window.location.origin}/form/${formId}`;

  const handleDownload = () => {
    const svg = document.getElementById("qr-code") as SVGElement;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.download = `qr-code-${formName.toLowerCase().replace(/\s+/g, "-")}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>QR-Code</CardTitle>
        <CardDescription>
          Scannen Sie diesen QR-Code, um das Formular zu öffnen.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center space-y-4">
        <div className="bg-white p-4 rounded-lg">
          <QRCodeSVG
            id="qr-code"
            value={formUrl}
            size={200}
            level="H"
            includeMargin
          />
        </div>
        <Button onClick={handleDownload} variant="outline">
          <Download className="mr-2 h-4 w-4" />
          QR-Code herunterladen
        </Button>
        <p className="text-sm text-muted-foreground text-center break-all">
          {formUrl}
        </p>
      </CardContent>
    </Card>
  );
} 
